// src/components/RevenueOverviewCard.tsx

import React from 'react';
import { Card } from 'antd';
// Corrected import path assuming Dashboard types are in a dedicated types file
// (You might need to adjust './../types/Dashboard' based on your exact file location)
import { RevenueCardData } from './Dashboard'; 

interface RevenueOverviewCardProps {
  data: RevenueCardData;
}

const RevenueOverviewCard: React.FC<RevenueOverviewCardProps> = ({ data }) => {
  return (
    
    <Card 
      className="shadow-none border antd_bde border-gray-100 p-0 overflow-hidden h-auto" 
   
      bodyStyle={{ padding: 0 }}
    >
      <div className="flex items-stretch min-h-[90px]"> {/* 'flex items-stretch' ensures the color bar fills the height */}
        
        {/* Left Color Bar (Vertical Border) */}
        {/* w-2 defines the width, and flex-shrink-0 prevents it from shrinking */}
        <div className={`w-2 ${data.colorClass} flex-shrink-0`}></div> 
        
        {/* Card Content Area */}
        {/* p-4 provides the necessary internal padding for the text */}
        <div className="p-4 flex-grow"> 
          <p className="text-xl font-semibold mb-1">{data.value}</p>
          <p className="text-sm text-gray-500">{data.title}</p>
        </div>
      </div>
    </Card>
  );
};

export default RevenueOverviewCard;